import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mnt",
  "use": "icon-mnt-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mnt\"><defs><style></style></defs><path d=\"M554.667 896v85.333h-85.334V896H128a42.667 42.667 0 0 1-42.667-42.667V256h853.334v597.333A42.667 42.667 0 0 1 896 896H554.667zM341.333 426.667a128 128 0 1 0 128 128h-128v-128zm213.334 0V512h256v-85.333h-256zm0 170.666v85.334h256v-85.334h-256zM85.333 128h853.334v85.333H85.333V128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol